export const getObjectFromQueryString = (query: string) => {
    const urlSearchParams = new URLSearchParams(query);
    return Object.fromEntries(urlSearchParams.entries());
};